var _foreignObject, _linearGradient, _path, _linearGradient2, _path2, _stop, _path3, _path4, _stop2, _path5, _path6, _path7, _path8, _stop3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _stop4, _path20, _stop5, _path21, _stop6, _path22, _linearGradient3, _path23, _linearGradient4, _path24, _stop7, _path25, _path26, _path27, _iPgf;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMbStarNWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsI: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    xmlns: "http://www.w3.org/2000/svg",
    id: "mb-stern_x5F_10",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    iExtraneous: "self"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "outer_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8,
    y1: 11.9,
    x2: 56,
    y2: 52.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CDD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B5BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A5ACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9BA3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#98A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#828A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#667075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#535C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#475158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#434D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475157"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outer_24_",
    fill: "url(#outer_1_)",
    d: "M63.3 32c0 17.3-14 31.3-31.3 31.3C14.7 63.3 0.7 49.3 0.7 32 0.7 14.7 14.7 0.7 32 0.7 49.3 0.7 63.3 14.7 63.3 32zM32 2.6C15.7 2.6 2.6 15.7 2.6 32c0 16.3 13.2 29.4 29.4 29.4 16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.5,
    y1: 13.1,
    x2: 54.5,
    y2: 50.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0B1F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81898D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B3B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D2D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEE0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M32 2.6C15.7 2.6 2.6 15.7 2.6 32c0 16.3 13.2 29.4 29.4 29.4 16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6zM32 59.5C16.8 59.5 4.5 47.2 4.5 32S16.8 4.5 32 4.5c15.2 0 27.5 12.3 27.5 27.5S47.2 59.5 32 59.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2374.7,
    y1: 772.9,
    x2: 2396.6,
    y2: 833.1,
    gradientTransform: "matrix(-1 0 0 -1 2417.6726 835.0071)"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E1E3E1"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#C1C5C4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#9BA1A2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#7D8487",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#687074",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#5B6469",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#576065",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "url(#SVGID_2_)",
    d: "M32 63.3c17.3 0 31.3-14 31.3-31.3C63.3 14.7 49.3 0.7 32 0.7c-17.3 0-31.3 14-31.3 31.3C0.7 49.3 14.7 63.3 32 63.3L32 63.3zM32 0c17.6 0 32 14.4 32 32 0 17.6-14.4 32-32 32C14.4 64 0 49.6 0 32 0 14.4 14.4 0 32 0L32 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2l0 0c16.5 0 29.8 13.4 29.8 29.9l0 0C61.8 48.5 48.5 61.8 32 61.8l0 0C15.5 61.8 2.2 48.5 2.2 32.1L2.2 32.1zM11.5 11.5C6.2 16.8 2.9 24.1 2.9 32.1l0 0c0 8 3.3 15.3 8.5 20.5l0 0C16.7 57.8 24 61.1 32 61.1l0 0c8 0 15.3-3.2 20.5-8.5l0 0c5.3-5.2 8.5-12.5 8.5-20.5l0 0c0-8-3.3-15.3-8.5-20.6l0 0C47.3 6.2 40 2.9 32 2.9l0 0C24 2.9 16.7 6.2 11.5 11.5L11.5 11.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2,
    y1: 8.1,
    x2: 45.8,
    y2: 55.9
  }, _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E1E3E1"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#C1C5C4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#9BA1A2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#7D8487",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#687074",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#5B6469",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#576065",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "url(#SVGID_3_)",
    d: "M32 59.6c-7.4 0-14.3-2.9-19.5-8.1C7.3 46.3 4.4 39.4 4.4 32c0-7.4 2.9-14.3 8.1-19.5 5.2-5.2 12.1-8.1 19.5-8.1 7.4 0 14.3 2.9 19.5 8.1 5.2 5.2 8.1 12.1 8.1 19.5 0 7.4-2.9 14.3-8.1 19.5C46.3 56.7 39.4 59.6 32 59.6L32 59.6zM32 58.8c7.1 0 13.9-2.8 18.9-7.8 5.1-5.1 7.8-11.8 7.8-18.9 0-7.1-2.8-13.9-7.8-18.9 -5.1-5.1-11.8-7.8-18.9-7.8 -7.1 0-13.9 2.8-18.9 7.8C8 18.1 5.2 24.9 5.2 32c0 7.1 2.8 13.9 7.8 18.9C18.1 56 24.9 58.8 32 58.8L32 58.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.4 31.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.3 45c-0.5-0.4-19.8-15.7-19.8-15.7L32 3.6c-0.3 0.1-0.7 0.4-0.9 0.8l-3.2 25L8 44.7c0 0-0.4 0.5-0.6 0.8C7.3 45.7 7.3 46 7.3 46.3c0 0 0 0 0 0l24.6-10.1 24.6 10.1c0 0 0 0 0 0C56.7 45.8 56.5 45.3 56.3 45z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#565F64",
    d: "M32.2 32.8l-0.2 4.6 22.6 9.1c0.8 0.4 1.4 0.2 2-0.2L32.5 32.7C32.4 32.6 32.2 32.7 32.2 32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.5,
    y1: 39.4,
    x2: 42.8,
    y2: 42.2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27343C"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00111E",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M32.2 32.8c0 0 1.3 2.3 2.8 3.9 2.1 2.3 4.9 3.9 4.9 3.9l14.7 5.9c0.8 0.4 1.4 0.2 2-0.2L32.5 32.7C32.4 32.6 32.2 32.7 32.2 32.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4AAAE",
    fillOpacity: 0.6,
    d: "M56.5 45.4c0-0.1-0.1-0.2-0.2-0.4l-20.6-15.1 -2.8 1.8c0 0 0.2 0.1 0.3 0 0.3-0.1 0.9-0.2 1.5 0C35.2 31.9 56.5 45.5 56.5 45.5 56.5 45.5 56.5 45.5 56.5 45.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#333E46",
    d: "M55.8 44.5L36.6 29.3l0 0 -0.9 0.6 20.6 15.2C56.2 44.9 56 44.7 55.8 44.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#565F64",
    d: "M32.5 31.3c-0.1 0.1-0.1 0.1-0.1 0.1s0 0.2 0.2 0.1c0.1-0.1 3-1.6 4-2.2l-3.5-24c-0.1-0.9-0.5-1.3-1.2-1.6l0.4 27.8L32.5 31.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4AAAE",
    fillOpacity: 0.6,
    d: "M30.8 5.3l0 1.3L28.6 28.7c0 0.3 0.1 0.6 0.4 0.8l1.3 1L31.2 6.1l0.1-1.9C31 4.4 30.9 4.8 30.8 5.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4AAAE",
    fillOpacity: 0.6,
    d: "M29.6 30.9l-1.2-1L8.1 44.6c0 0-0.6 0.4-0.7 0.8l0 0c0 0 0 0 0 0l0 0 0.7-0.4 0 0 21.3-13.4C29.8 31.4 29.9 31.2 29.6 30.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#565F64",
    d: "M31.7 32.8c0-0.1-0.1-0.2-0.2-0.1L7.3 46.4c0.6 0.4 1.2 0.5 2 0.2l22.6-9.1L31.7 32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6,
    y1: 29.1,
    x2: 36.8,
    y2: 24.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#02131F",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M32.4 31.4l0.1-0.1C32.4 31.4 32.4 31.4 32.4 31.4L32.4 31.4c0 0 0 0.1 0.1 0.1 0 0 0.1 0 0.1 0 0.1-0.1 3-1.6 4-2.2l-0.4-2.9h0L33.1 5.3c0-0.4-0.1-0.7-0.3-0.9 0 0 1.5 20.2 1.5 22.4C34.3 29.7 32.4 31.4 32.4 31.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 36.4,
    x2: 27.8,
    y2: 37.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#02131F",
      stopOpacity: 0
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    fillOpacity: 0.8,
    d: "M31.7 32.8c0-0.1-0.1-0.2-0.2-0.1L7.3 46.4c0.6 0.4 1.2 0.5 2 0.2l22.6-9.1L31.7 32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8,
    y1: 41.9,
    x2: 20.2,
    y2: 40.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02131F",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_7_)",
    d: "M9.3 46.5l22.6-9.1 -0.2-4.4c-0.4 1.2-1.1 2.5-3 3.5 0 0 0 0 0 0 -1.4 0.8-14.8 7.4-19.6 9.7 -0.3 0.2-0.7 0.3-0.9 0.4C8.6 46.8 8.9 46.7 9.3 46.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.6,
    y1: 17.2,
    x2: 32.2,
    y2: 17.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#02131F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#02131F",
      stopOpacity: 0
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M32.5 31.3c-0.1 0.1-0.1 0.1-0.1 0.1s0 0.2 0.2 0.1c0.1-0.1 3-1.6 4-2.2l-3.5-24c-0.1-0.9-0.5-1.3-1.2-1.6l0.4 27.8L32.5 31.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.7,
    y1: 17.1,
    x2: 33.4,
    y2: 17.4
  }, _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27343C"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B474E",
      stopOpacity: 0
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M32.5 31.3c-0.1 0.1-0.1 0.1-0.1 0.1s0 0.2 0.2 0.1c0.1-0.1 3-1.6 4-2.2l-3.5-24c-0.1-0.9-0.5-1.3-1.2-1.6l0.4 27.8L32.5 31.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.4,
    y1: 32.9,
    x2: 27.5,
    y2: 49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24303A",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25323B",
      stopOpacity: 0
    }
  }), _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27343C"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M5.1 44.4C4.4 42.8 0.4 35 4.8 20h-1.7c-0.9 3-1.6 4.8-2 7.5 0 0-0.2 1-0.3 2.1 -0.1 1.1-0.1 1.7-0.1 2.4 0 6 1.5 9.5 1.5 9.5 1.6 5 4.4 9.5 8.2 12.9 3.3 2.9 8.4 5.1 12.6 5.9C22.3 60.2 10.3 55.1 5.1 44.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 37.4,
    x2: 32,
    y2: 32.6
  }, _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A5ABAF"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A5ABAF",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M32.4 32.6h-0.9v0c0.1 0 0.2 0 0.2 0.1l0.2 4.6 0 0 0.1 0 0.2-4.6c0-0.1 0.1-0.2 0.2-0.1V32.6z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7,
    y1: 2.3,
    x2: 47.7,
    y2: 63.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DEE0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C5C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9EA4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82898C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6B7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434D54"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M42 2.3c10.5 4 20.4 15 20.4 28.9C62.4 48 49 61.7 32 61.7v1.6c17 0 31.3-14 31.3-31.3C63.3 18.2 54.5 6.6 42 2.3z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.1,
    y1: 0.7,
    x2: 32.1,
    y2: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DEE0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C5C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9EA4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82898C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6B7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434D54"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M32.3 0.7C32.2 0.7 32.1 0.7 32 0.7c0.1 0 0.2 0 0.3 0C32.3 0.7 32.3 0.7 32.3 0.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.3,
    y1: 8.1,
    x2: 43.8,
    y2: 27.9
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#27343C"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#2B373F",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#36424A",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#49545B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#646D73",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#868D92",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#B0B5B8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#E1E3E4",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M58.8 20.2C51.8 4.1 36 3.2 35.1 3.1c0 0 0 0-0.1 0l0 0c12.1 2.2 19.8 10.1 22.5 18.4 0 0 0 0.1 0 0.1 1.2 3.2 1.8 6.6 1.9 10.3 0.1 3.5-0.7 7.4-2.2 11C57.1 43.4 57 44 56.9 44h1.6C63.3 35 61.2 25.9 58.8 20.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2l0 0c16.5 0 29.8 13.4 29.8 29.9l0 0C61.8 48.5 48.5 61.8 32 61.8l0 0C15.5 61.8 2.2 48.5 2.2 32.1L2.2 32.1zM11.5 11.5C6.2 16.8 2.9 24.1 2.9 32.1l0 0c0 8 3.3 15.3 8.5 20.5l0 0C16.7 57.8 24 61.1 32 61.1l0 0c8 0 15.3-3.2 20.5-8.5l0 0c5.3-5.2 8.5-12.5 8.5-20.5l0 0c0-8-3.3-15.3-8.5-20.6l0 0C47.3 6.2 40 2.9 32 2.9l0 0C24 2.9 16.7 6.2 11.5 11.5L11.5 11.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#333F47",
    d: "M7.9 44.8L7.9 44.8l20.4-14.7c1.1 0.6 2.9 1.4 3.1 1.4 0.2 0.1 0.2-0.1 0.2-0.1l-2.5-2.1c-0.3-0.2-0.4-0.5-0.4-0.8l2.4-24.1c-0.1 0.1-0.1 0.3-0.2 0.4 -0.1 0.2-0.1 0.3-0.1 0.5l-3.5 24.1L8.1 44.5C8 44.6 7.9 44.7 7.9 44.8z"
  })))), _iPgf || (_iPgf = /*#__PURE__*/React.createElement("iPgf", {
    id: "adobe_illustrator_pgf"
  }, "\r\n   BftkGWhGUVG7c3mngehYJhilRT+ayxAgEchAA0xWBqF/yFGp5Vioz4weFgszqFC1WGuBqMY6RS5D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\r\n1bfz/+Yn+Eo8vNdbf77R+X+TJPhe\r\n   ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbStarNWeb);
export default __webpack_public_path__ + "static/media/MB-star_n_web.dfc94c9134926cd3b12f647e6a8afefc.svg";
export { ForwardRef as ReactComponent };